// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  LogAppID: 'BundleSales-Client',
  loggerApiUrl: 'https://tlogger-api.bezeq.co.il/api/data/SendData',
  baseApiUrl: 'https://tself.bezeq.co.il/api/api',
  headerHtmlUrl: '//media.bezeq.co.il/common/master/staticHtml/header.html',
  menuJsUrl: '//media.bezeq.co.il/common/master/store/menuJs.js',
  menuCSSUrl: '//media.bezeq.co.il/common/master/store/menuCss.css',
  showCaptcha: false,
  showCaptchaPhase1: false,
  brazeApiKey: '70af6714-f4c0-4c60-8537-1909290b12e9',
  brazeSdkEndPoint: 'sdk.fra-02.braze.eu',
  site_key: '6LchrKgUAAAAAFTmTq4PsdoRfI7wF6Pbk5FfwNBT',
  isLocal: false,
  isMocked: true,
  CloseErrorMessageUrlNew: "https://www.bezeq.co.il/internetandphone/packages/internet_self/",
  // CloseErrorMessageUrlExist: "https://www.bezeq.co.il/internetandphone/packages/internetexisting_selftest/",
  CloseErrorMessageUrlExist: "https://www.bezeq.co.il/internetandphone/packages/existing_self/",
  CloseErrorMessageUrlWsFilter: "https://www.bezeq.co.il/internetandphone/internet/wireless_net/filtersites/?WT.isp=menu",
  CloseErrorMessageUrlVas: "https://www.bezeq.co.il/",
  CloseErrorMessageUrlWifiKids: "https://www.bezeq.co.il/internetandphone/appsandservices/wifi_kids/",
  CloseErrorMessageUrlTel:"https://www.bezeq.co.il/internetandphone/internet/internet_be",
  CloseErrorMessageUrlMoving: "https://www.bezeq.co.il/",
  CloseErrorMessageUrl: "https://www.bezeq.co.il/",
  CloseErrorMessageUrlElct: "https://www.bezeq.co.il/benergy/",

  loggerApiData: {
    general: {
      appId: 'self_client',
      app_side: 'client_side'
    },
    httpLogs: {
      type: 'HttpRequest_Error'
    },
    httpF5Logs: {
      type: 'F5_Error'
    },
    events: {
      type: 'events_trace',
    }
  },
  webTrends: {
    appId: 'self_client'
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
